import { settings } from 'settings';
import { GeonorgeAddress } from 'types/Geonorge/GeonorgeAddress';
import { GeonorgeResponse } from 'types/Geonorge/GeonorgeResponse';
import Fetch from 'utils/fetch';

export const fetchAddressSuggestion = async (
  keyword?: string
): Promise<Array<GeonorgeAddress>> => {
  let suggestion: Array<GeonorgeAddress> = [];

  try {
    /* The URL used is from Geonorge */
    /* Source : https://kartkatalog.geonorge.no/metadata/adresse-rest-api/44eeffdc-6069-4000-a49b-2d6bfc59ac61 */
    /* This is because the Mapbox Search API still in Beta version and not opened for public */
    /*  */
    const url = `${settings.newApiUrl}/geonorge/search?keyword=${keyword}`;

    const response = await Fetch.get({ url });
    const suggestionResponse: GeonorgeResponse = await response.json();

    suggestion = suggestionResponse?.adresser || [];
  } catch (e) {
    console.error('Error retrieving the address from Geonorge', e);
  }

  return suggestion;
};
